import classNames from "classnames";
import QRCode from "qrcode.react";

import { LISCaseList } from "pwapi";

import { useSelectedLab } from "hooks/useSelectedLabStation";
import { labelForBlock } from "util/blockUtils";
import { truncatePatientName } from "util/patientUtils";

const CassetteBarcode = ({
  id,
  printCase,
  printer,
}: {
  id: number;
  printCase: LISCaseList;
  printer?: string | null;
}) => {
  const lab = useSelectedLab();
  const block = printCase?.blocks.find((b) => b.id === id);

  const patientName = truncatePatientName(printCase?.patient);

  return block ? (
    <div
      className={classNames(
        "DecoratedBarcode",
        "DecoratedBarcode--block",
        `DecoratedBarcode--${printer}`,
        {
          "DecoratedBarcode--zebraPrintChanges":
            printer === "zebra" && lab.settings?.zebra_print_changes?.active,
        }
      )}
    >
      <div className="Barcode BlockBarcode">
        <div className="Barcode__label">
          <p className="Barcode__accession">
            <strong>
              <code>{printCase?.accession}</code>
            </strong>
          </p>
          <p className="Barcode__patient">{patientName}</p>
        </div>

        <figure>
          <div className="Barcode__qr">
            <QRCode
              value={`block-${block.id}`}
              size={36}
              bgColor={"#ffffff"}
              fgColor={"var(--black)"}
              level={"Q"}
              includeMargin={false}
              renderAs={"svg"}
            />
          </div>
          <figcaption>{labelForBlock(block, printCase)}</figcaption>
        </figure>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @page { margin: 0; }
          `,
        }}
      />
    </div>
  ) : null;
};

export default CassetteBarcode;
